import Vue from 'vue';

const TrackUtils = {

    uploadFullTrack(requestObj) {
        return Vue.axios
            .put(`track`, requestObj)
            .then(response => {
                return response;
            });
    },
    countTracks() {
        return Vue.axios.get(`track`);
    }

}

export default TrackUtils;
